// countryCodes.js
// ISO 3166-1 alpha-2 country code mapping
const COUNTRY_CODE_MAP = {
  Afghanistan: 'af',
  Albania: 'al',
  Algeria: 'dz',
  Andorra: 'ad',
  Angola: 'ao',
  Antigua_and_Barbuda: 'ag',
  Argentina: 'ar',
  Armenia: 'am',
  Australia: 'au',
  Austria: 'at',
  Azerbaijan: 'az',
  Bahamas: 'bs',
  Bahrain: 'bh',
  Bangladesh: 'bd',
  Barbados: 'bb',
  Belarus: 'by',
  Belgium: 'be',
  Belize: 'bz',
  Benin: 'bj',
  Bhutan: 'bt',
  Bolivia: 'bo',
  Bosnia_and_Herzegovina: 'ba',
  Botswana: 'bw',
  Brazil: 'br',
  Brunei: 'bn',
  Bulgaria: 'bg',
  Burkina_Faso: 'bf',
  Burundi: 'bi',
  Cambodia: 'kh',
  Cameroon: 'cm',
  Canada: 'ca',
  Cape_Verde: 'cv',
  Central_African_Republic: 'cf',
  Chad: 'td',
  Chile: 'cl',
  China: 'cn',
  Colombia: 'co',
  Comoros: 'km',
  Congo: 'cg',
  Costa_Rica: 'cr',
  Croatia: 'hr',
  Cuba: 'cu',
  Cyprus: 'cy',
  Czechia: 'cz',
  Denmark: 'dk',
  Djibouti: 'dj',
  Dominica: 'dm',
  Dominican_Republic: 'do',
  Ecuador: 'ec',
  Egypt: 'eg',
  El_Salvador: 'sv',
  Equatorial_Guinea: 'gq',
  Eritrea: 'er',
  Estonia: 'ee',
  Eswatini: 'sz',
  Ethiopia: 'et',
  Fiji: 'fj',
  Finland: 'fi',
  France: 'fr',
  Gabon: 'ga',
  Gambia: 'gm',
  Georgia: 'ge',
  Germany: 'de',
  Ghana: 'gh',
  Greece: 'gr',
  Grenada: 'gd',
  Guatemala: 'gt',
  Guinea: 'gn',
  Guinea_Bissau: 'gw',
  Guyana: 'gy',
  Haiti: 'ht',
  Honduras: 'hn',
  Hungary: 'hu',
  Iceland: 'is',
  India: 'in',
  Indonesia: 'id',
  Iran: 'ir',
  Iraq: 'iq',
  Ireland: 'ie',
  Israel: 'il',
  Italy: 'it',
  Jamaica: 'jm',
  Japan: 'jp',
  Jordan: 'jo',
  Kazakhstan: 'kz',
  Kenya: 'ke',
  Kiribati: 'ki',
  Korea_North: 'kp',
  Korea_South: 'kr',
  Kuwait: 'kw',
  Kyrgyzstan: 'kg',
  Laos: 'la',
  Latvia: 'lv',
  Lebanon: 'lb',
  Lesotho: 'ls',
  Liberia: 'lr',
  Libya: 'ly',
  Liechtenstein: 'li',
  Lithuania: 'lt',
  Luxembourg: 'lu',
  Madagascar: 'mg',
  Malawi: 'mw',
  Malaysia: 'my',
  Maldives: 'mv',
  Mali: 'ml',
  Malta: 'mt',
  Marshall_Islands: 'mh',
  Mauritania: 'mr',
  Mauritius: 'mu',
  Mexico: 'mx',
  Micronesia: 'fm',
  Moldova: 'md',
  Monaco: 'mc',
  Mongolia: 'mn',
  Montenegro: 'me',
  Morocco: 'ma',
  Mozambique: 'mz',
  Myanmar: 'mm',
  Namibia: 'na',
  Nauru: 'nr',
  Nepal: 'np',
  Netherlands: 'nl',
  New_Zealand: 'nz',
  Nicaragua: 'ni',
  Niger: 'ne',
  Nigeria: 'ng',
  North_Macedonia: 'mk',
  Norway: 'no',
  Oman: 'om',
  Pakistan: 'pk',
  Palau: 'pw',
  Palestine: 'ps',
  Panama: 'pa',
  Papua_New_Guinea: 'pg',
  Paraguay: 'py',
  Peru: 'pe',
  Philippines: 'ph',
  Poland: 'pl',
  Portugal: 'pt',
  Qatar: 'qa',
  Romania: 'ro',
  Russia: 'ru',
  Rwanda: 'rw',
  Saint_Kitts_and_Nevis: 'kn',
  Saint_Lucia: 'lc',
  Saint_Vincent_and_the_Grenadines: 'vc',
  Samoa: 'ws',
  San_Marino: 'sm',
  Sao_Tome_and_Principe: 'st',
  Saudi_Arabia: 'sa',
  Senegal: 'sn',
  Serbia: 'rs',
  Seychelles: 'sc',
  Sierra_Leone: 'sl',
  Singapore: 'sg',
  Slovakia: 'sk',
  Slovenia: 'si',
  Solomon_Islands: 'sb',
  Somalia: 'so',
  South_Africa: 'za',
  South_Sudan: 'ss',
  Spain: 'es',
  Sri_Lanka: 'lk',
  Sudan: 'sd',
  Suriname: 'sr',
  Sweden: 'se',
  Switzerland: 'ch',
  Syria: 'sy',
  Taiwan: 'tw',
  Tajikistan: 'tj',
  Tanzania: 'tz',
  Thailand: 'th',
  Timor_Leste: 'tl',
  Togo: 'tg',
  Tonga: 'to',
  Trinidad_and_Tobago: 'tt',
  Tunisia: 'tn',
  Turkey: 'tr',
  Turkmenistan: 'tm',
  Tuvalu: 'tv',
  Uganda: 'ug',
  Ukraine: 'ua',
  United_Arab_Emirates: 'ae',
  United_Kingdom: 'gb',
  United_States: 'us',
  Uruguay: 'uy',
  Uzbekistan: 'uz',
  Vanuatu: 'vu',
  Vatican_City: 'va',
  Venezuela: 've',
  Vietnam: 'vn',
  Yemen: 'ye',
  Zambia: 'zm',
  Zimbabwe: 'zw',
};

export default COUNTRY_CODE_MAP;
